
export default function setupErrorGuard(router) {
  router.onError((error) => {
  })
}
